import React from 'react';
import Dialog from "@mui/material/Dialog";
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';

const ConfirmDialog = (props) => {
  const { title, children, open, onConfirm, onClose, cancelButtonText = 'No', confirmButtonText = 'Yes' } = props;

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") {
      return;
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="confirm-dialog"
    >
      <DialogTitle id="confirm-dialog">{title}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText>
          {children}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          size="small"
          onClick={onClose}
          sx={{
            color: '#333330',
            backgroundColor: '$bg-color-primary',
            border: '1px solid #82C027',
            boxShadow: '0px 1px 2px #6F7687',
            borderRadius: '5px',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '$bg-color-primary',
              boxShadow: 'none'
            }
          }}

        >
          {cancelButtonText}
        </Button>
        <Button
          variant="contained"
          size="small"
          sx={{
            color: '#333330',
            backgroundColor: '#82C027',
            boxShadow: '0px 1px 2px #6F7687',
            borderRadius: '5px',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#82C027',
              boxShadow: 'none'
            }
          }}
          onClick={() => {
            //setOpen(false);
            onConfirm();
            onClose();
          }}
        >
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ConfirmDialog;